import { ObjectSchemaType } from "commons/ultilities/dynamic-form/hooks/use-form";
import { InputType } from "commons/ultilities/dynamic-form/models/control";
import { numberNanable } from "commons/ultilities/validation";
import { IUpdatePaperMaterial } from "mobx-stores/_models/paper-inventory/paper-material";
import { number, string } from "yup";
import {
  getPaperPaperSpecificationTypeOptions,
  getPaperTypeOptions,
} from "../share";

export const getUpdatePaperMaterialSchema =
  (): ObjectSchemaType<IUpdatePaperMaterial> => ({
    id: {
      type: InputType.none,
    },
    code: {
      type: InputType.text,
      gridSize: 12,
      label: "Mã số",
      validattionYupSchema: string().trim().required().max(50),
    },
    typeSelect: {
      type: InputType.select,
      gridSize: 6,
      label: "Loại giấy",
      validattionYupSchema: string().trim().required(),
      optionItems: getPaperTypeOptions(),
    },
    type: {
      type: InputType.text,
      gridSize: 6,
      label: "",
      validattionYupSchema: string().trim().required().max(50),
    },
    gsm: {
      type: InputType.number,
      gridSize: 12,
      label: "GSM",
      validattionYupSchema: number().required(),
    },
    specificationTypeSelect: {
      type: InputType.select,
      gridSize: 6,
      label: "Quy cách giấy - dạng",
      validattionYupSchema: string().trim(),
      optionItems: getPaperPaperSpecificationTypeOptions(),
    },
    specificationType: {
      type: InputType.text,
      gridSize: 6,
      label: "",
      validattionYupSchema: string().max(255),
      disabled: true,
    },
    specificationSize: {
      type: InputType.number,
      gridSize: 6,
      label: "Quy cách giấy - khổ",
      validattionYupSchema: numberNanable(),
    },
    specificationLength: {
      type: InputType.number,
      gridSize: 6,
      label: "Quy cách giấy - dài",
      validattionYupSchema: numberNanable(),
    },
  });
